<ng-template #ultimoFechamentoTemplate>
  <div class="fechamento-popover-content">
    <div class="fechamento-popover-title">
      <span>Indicador de recência do fechamento</span>
      <span *ngIf="ultimoFechamentoLoading" class="fechamento-loading">Carregando...</span>
    </div>

    <div *ngIf="!ultimoFechamentoLoading && ultimoFechamentoSemDados" class="fechamento-empty">
      Não retornou dados de fechamento no momento.
    </div>

    <div *ngIf="!ultimoFechamentoLoading && !ultimoFechamentoSemDados && (ehExecutivo || meuFechamentoNoIndicador)" class="fechamento-executivo">
      <div class="fechamento-row">
        <span class="fechamento-row-label">Sua última data</span>
        <strong class="fechamento-row-value">{{ ultimoFechamentoDataFormatada }}</strong>
      </div>

      <div class="fechamento-termometro">
        <div class="fechamento-termometro-top">
          <span class="fechamento-termometro-dias">
            Há <strong>{{ ultimoFechamentoDias }}</strong> dia(s)
          </span>
        </div>
      </div>
    </div>

    <div *ngIf="!ultimoFechamentoLoading && !ultimoFechamentoSemDados && !ehExecutivo" class="fechamento-lista">
      <div class="fechamento-hint" *ngIf="(blocosPorGerente.length || outrosExecutivos.length) && !meuFechamentoNoIndicador">
        Lista agrupada por gerente executivo e pelo time de cada um, da data mais antiga para a mais recente. Executivos sem gerente executivo aparecem em Outros.
      </div>
      <div class="fechamento-hint" *ngIf="!blocosPorGerente.length && !outrosExecutivos.length && meuFechamentoNoIndicador">
        Não há outros executivos nesta lista — só consta o seu registro nesta consulta.
      </div>

      <div class="fechamento-lista-container" *ngIf="blocosPorGerente.length || outrosExecutivos.length">
        <ng-container *ngFor="let bloco of blocosPorGerente">
          <div class="fechamento-bloco-gerente">
            <div class="fechamento-lista-grupo-header">
              <div class="fechamento-lista-grupo-titulo">Gerente executivo</div>
            </div>
            <div *ngIf="bloco.gerente" class="fechamento-lista-item fechamento-lista-item--gerente">
              <div class="fechamento-lista-item-nome">{{ bloco.gerente.Executivo }}</div>
              <div class="fechamento-lista-item-meta">
                <span class="fechamento-meta-dados">
                  {{ parseDataUltimoFechamentoParaTexto(bloco.gerente.DataUltimoFechamento) }}
                </span>
                <span class="fechamento-meta-dias">Há {{ bloco.gerente.diasDesdeUltimoFechamento }} dia(s)</span>
              </div>
            </div>
            <div *ngIf="!bloco.gerente" class="fechamento-lista-item fechamento-lista-item--gerente">
              <div class="fechamento-lista-item-nome">{{ bloco.nomeGerente }}</div>
              <div class="fechamento-lista-item-meta">
                <span class="fechamento-meta-dados">—</span>
                <span class="fechamento-meta-dias">—</span>
              </div>
            </div>

            <div class="fechamento-lista-grupo-header fechamento-lista-grupo-header--sub" *ngIf="bloco.executivosDoTime.length">
              <div class="fechamento-lista-grupo-titulo">Executivos do time</div>
            </div>
            <div *ngFor="let item of bloco.executivosDoTime" class="fechamento-lista-item">
              <div class="fechamento-lista-item-nome">{{ item.Executivo }}</div>
              <div class="fechamento-lista-item-meta">
                <span class="fechamento-meta-dados">
                  {{ parseDataUltimoFechamentoParaTexto(item.DataUltimoFechamento) }}
                </span>
                <span class="fechamento-meta-dias">Há {{ item.diasDesdeUltimoFechamento }} dia(s)</span>
              </div>
            </div>
          </div>
        </ng-container>

        <div class="fechamento-bloco-outros" *ngIf="outrosExecutivos.length">
          <div class="fechamento-lista-grupo-header">
            <div class="fechamento-lista-grupo-titulo">Outros</div>
          </div>
          <div *ngFor="let item of outrosExecutivos" class="fechamento-lista-item">
            <div class="fechamento-lista-item-nome">{{ item.Executivo }}</div>
            <div class="fechamento-lista-item-meta">
              <span class="fechamento-meta-dados">
                {{ parseDataUltimoFechamentoParaTexto(item.DataUltimoFechamento) }}
              </span>
              <span class="fechamento-meta-dias">Há {{ item.diasDesdeUltimoFechamento }} dia(s)</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<div class="fechamento-edu-anchor">
  <div
    class="fechamento-popover-trigger"
    [nbPopover]="ultimoFechamentoTemplate"
    nbPopoverPlacement="bottom"
    nbPopoverStatus="primary"
    nbPopoverClass="fechamento-popover"
    nbPopoverTrigger="hover"
    nbPopoverDelay="300">
    <div class="fechamento-icon-container">
      <nb-icon icon="thermometer-outline" class="fechamento-icon"></nb-icon>
    </div>
  </div>
  <div
    *ngIf="mostrarTooltipTermometro"
    class="header-edu-tooltip header-edu-tooltip--termometro"
    (click)="$event.stopPropagation()">
    <div class="tooltip-arrow"></div>
    <div class="tooltip-content">
      <p>
        <strong>Dica:</strong> Este ícone mostra a <strong>última data de fechamento</strong> registrada. Passe o mouse por cima quando quiser ver o resumo.
      </p>
      <div class="tooltip-footer">
        <button type="button" class="got-it-btn" (click)="fecharTooltipTermometro()">
          Entendi
        </button>
      </div>
    </div>
  </div>
</div>
